<template>
    <div class="title">
        <span>{{ title }}</span> 
        <em v-dompurify-html="name"></em> 
    </div>
</template>
<script> 
    export default {
        name: "head-title",
        components: { 
        },
        props: { 
            name: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return { 
            }
        },
        created() {  
        },
        methods: {
         
        }
    }
</script>
<style lang="scss" scoped> 
.title{
    padding:60px 0;
    text-align: center; 
    color:#354EAC;
    font-weight: bold;
    span{
        display: block; 
        height: 42px;
        font-size: 42px; 
        line-height: 42px;
        margin-bottom: 20px;
    }
    em{
        display: block;
        font-size:20px;
        color:#666;
        font-weight: normal;
    }
}
@media only screen and (max-width: 750px) { 
    .title{
        padding: 20px 0; 
        span{
            margin-bottom: 5px;
            font-size:24px;
        }
        em{
            font-size: 14px;
        }
    }
}
</style>